export default __webpack_public_path__ + "static/media/date-night-demo.ac36787b.gif";